const masterEn = {
    country: require('../../lang/en/master/Country').default,
    district: require('../../lang/en/master/District').default,
    pin: require('../../lang/en/master/Pin').default,
    place: require('../../lang/en/master/Place').default,
    state: require('../../lang/en/master/State').default,
    tehsil: require('../../lang/en/master/Tehsil').default,
    city: require('../../lang/en/master/City').default,
    category: require('../../lang/en/master/Category').default,
    subCategory: require('../../lang/en/master/SubCategory').default,
    service: require('../../lang/en/master/Service').default,
    plan: require('../../lang/en/master/Plan').default,
    designation: require('../../lang/en/master/Designation').default,
    expenseCategory: require('../../lang/en/master/ExpenseCategory').default,
};

export default masterEn;